import { render, staticRenderFns } from "./IncomingRequest.vue?vue&type=template&id=6af506b9&scoped=true&"
import script from "./IncomingRequest.vue?vue&type=script&lang=js&"
export * from "./IncomingRequest.vue?vue&type=script&lang=js&"
import style0 from "./IncomingRequest.vue?vue&type=style&index=0&id=6af506b9&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6af506b9",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
